module.exports = __webpack_public_path__ + "fea47dfa.png";